import * as React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

export default function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
      {"Copyright © "}
      <Link href="https://github.com/Shoebtamboli">Shoeb Tamboli&nbsp;</Link>
      {new Date().getFullYear()}
    </Typography>
  );
}
